import AppLayout from "../components/app-layoout";
import { Box, Stack, Typography, styled, Divider, Button } from "@mui/material";
import { LayoutContainer } from "../components/app-layoout/container";
import Possibilities from "../components/Property/Possibilities/Possibilities";
import { useCopyAndPaste } from "../hooks/useCopyAndPaste";
import { toast } from "react-hot-toast";
import { useUserData } from "../hooks/use-data-user";
import { useDataListProperties } from "../hooks/use-data-list-properties";
import { useAuthStore } from "../stores/authStore";
import { Link } from 'react-router-dom';

export const StyledGradienthBox = styled(Box)(({ theme }) => ({
  background: `linear-gradient(154.12deg, rgb(38, 38, 38) -27.695%,rgba(38, 38, 38, 0) 40.055%)`,
  position: "relative",
  paddingTop: '100px',
  paddingBottom: '50px',
  [theme.breakpoints.down("sm")]: {
    paddingTop: '50px',
    paddingBottom: '25px',
  },
}));

const Properties = () => {
  const accessToken = useAuthStore((state) => state.auth.accessToken);
  const { dataListPropertiesQuery } = useDataListProperties(100);
  const { userDataQuery } = useUserData();
    const { copy } = useCopyAndPaste();
    const handleCopy = () => {
      const baseUrl = `${process.env.REACT_APP_REWARDS}/invitation?sponsor=${userDataQuery.data?.username}&app=estate`;
      copy(baseUrl);
      toast.success("Link de referido copiado", {
        style: {
          backgroundColor: "black",
          fontWeight: "700",
          fontFamily: "Arial",
          color: "#fff",
          fontSize: "16px",
          padding: "16px",
          borderRadius: "8px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        },
      });
    };

    const handleCopyEstateLink = (fullUrl) => {
    copy(fullUrl);
    toast.success("Link de referido copiado", {
      style: {
        backgroundColor: "black",
        fontWeight: "700",
        fontFamily: "Arial",
        color: "#fff",
        fontSize: "16px",
        padding: "16px",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      },
    });
  };

  return (
    <AppLayout>
      <Stack py="40px">
        <StyledGradienthBox>
          <LayoutContainer>
            <Stack spacing={2}>
              <Typography variant="h2" color="text.secondary" mb={2} maxWidth={1300}>
                Accede a las mejores oportunidades de Tokenización. Invierte en propiedades fraccionadas desde cualquier lugar.
              </Typography>
              <Typography
                color="text.primary"
                fontWeight={500}
                width={{ xs: "100%", md: "72%" }}
                sx={{ fontSize: "1.1em" }}
              >
                Conoce nuestro portafolio inmobiliario de propiedades disponibles en fracciones digitales (tokens). 
                Cada propiedad representa una oportunidad real de generar ingresos por renta y plusvalía. 
              </Typography>
              <Box display="flex" flexDirection={{ xs: "column", md: "row" }} width="100%">
                <Stack spacing={2} width={{ xs: "100%", md: "44%" }}>
                  {accessToken ? (
                    <>
                      <Typography
                        variant="h5"
                        color="text.primary"
                        fontWeight={600}
                        width="100%"
                      >
                        Súmate a la expansión, comparte y gana.
                      </Typography>
                      <Box display="flex" flexDirection={{xs: "column", md: "row" }} gap={2}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleCopy}
                          sx={{
                            display: "flex",
                            backgroundColor: "#a95052",
                            "&:hover": { backgroundColor: "#8c3e47" },
                            fontSize: "16px",
                            fontWeight: 800,
                          }}
                        >
                          Invita a un amigo
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleCopyEstateLink(`https://plusvalestate.com/?sponsor=${userDataQuery.data?.username}`)}
                          sx={{
                            display: "flex",
                            backgroundColor: "#a95052",
                            "&:hover": { backgroundColor: "#8c3e47" },
                            fontSize: "16px",
                            fontWeight: 800,
                          }}
                        >
                          Plusval Estate
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => handleCopyEstateLink(`https://plusvalestate.com/promociones/ganate-un-depa/?sponsor=${userDataQuery.data?.username}`)}
                          sx={{
                            display: "flex",
                            backgroundColor: "#a95052",
                            "&:hover": { backgroundColor: "#8c3e47" },
                            fontSize: "16px",
                            fontWeight: 800,
                          }}
                        >
                          Promociones
                        </Button>
                      </Box>
                      <Typography
                        sx={{
                          color: '#fff',
                          fontSize: '14px',
                          fontStyle: 'italic',
                          maxWidth: '480px',
                        }}
                      >
                        (Elige el enlace que quieras compartir, haz clic y listo — se copiará al instante. 
                        Pégalo en tus redes o mándalo por WhatsApp para invitar a más personas.)
                      </Typography>
                    </>
                  ) : (
                    <Box display="flex" pt={{xs: 0, md: 5}} gap={2}>
                      <Button
                          variant="contained"
                          color="primary"
                          component={Link}
                          to="/sign-in"
                          sx={{
                            backgroundColor: "#a95052",
                            "&:hover": { backgroundColor: "#8c3e47" },
                            fontSize: "16px",
                            fontWeight: 800,
                            maxWidth: '200px',
                          }}
                        >
                          Iniciar Sesión
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          component={Link}
                          to="/sign-up"
                          sx={{
                            backgroundColor: "#a95052",
                            "&:hover": { backgroundColor: "#8c3e47" },
                            fontSize: "16px",
                            fontWeight: 800,
                            maxWidth: '200px',
                          }}
                        >
                          Registrarse
                        </Button>
                    </Box>
                  )}
                  <Typography
                    paddingTop={{ xs: 2, md: 5 }}
                    variant="h5"
                    color="text.primary"
                    fontWeight={600}
                    width="100%"
                  >
                    Haz clic en cada propiedad para ver los detalles.
                  </Typography>
                </Stack>
                <Stack width={{ xs: "100%", md: "56%" }}>
                  <Typography
                    sx={{ 
                      fontSize: {
                        xs: '40px',
                        md: '120px',
                      },
                      letterSpacing: {
                        xs: '1px',   
                        md: '5px',   
                      },
                      height: {
                        xs: 45,    
                        md: 110,     
                      },
                      display: 'flex', 
                      alignItems: 'center',
                    }}
                    color="text.secondary"
                    fontWeight={500}
                    width="100%"
                    pt={{ xs: 3, md: 1 }}
                  >
                    400+ millones
                  </Typography>
                  <Typography
                    variant="h2"
                    color="text.secondary"
                    fontWeight={600}
                    sx={{
                      fontSize: { xs: '1.2rem', md: '2.7rem' }
                    }}
                    width={{ xs: "100%", md: "80%" }}
                  >
                    de dólares en propiedades en venta tradicional y tokenizada
                  </Typography>
                </Stack>
              </Box>
            </Stack>
          </LayoutContainer>
        </StyledGradienthBox>

        <Divider variant="fullWidth" orientation="horizontal" />

        <Possibilities dataListPropertiesQuery={dataListPropertiesQuery} />
      </Stack>
    </AppLayout>
  );
};

export default Properties;
